import angular from 'angular';

import routeProviderConfig from './configs/routeProvider.config';

import community from './components/community/community.component';

/**
 * @ngdoc overview
 * @name community
 * @description
 * This module handles everything for the Community section.
 */
const communityModule = angular.module('community', [])
.config(routeProviderConfig)
.component('community', community);

export default communityModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/community/index.js